import React, { useState, Fragment } from "react";

const ImagePlaceholder = ({className}) => {
    return (
    <div className={`image-placeholder w-36 h-36 rounded-lg bg-slate-100 ${className}`}></div>
    )
};


export default ImagePlaceholder;